export const tokenType = {
  JWT: 'JWT'
}
